var map = {
	"./BottleFourH150.png": 98246,
	"./BottleThreeH150.png": 12340,
	"./VinoBiancoH150.png": 68732,
	"./VinoRosatoH150.png": 69233,
	"./VinoRossoH150.png": 43328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80811;